const smartBar = {
  more: "Ещё",
  overflow: "Ещё виджеты",
  lockWidget: "Закрепить виджет",
  unlockWidget: "Открепить виджет",
  pinnedSettings: "Настройки",
  pinnedStore: "Магазин виджетов",
  searchShortcuts: "Поиск...",
  barSettings: "Настройки панели",
  widgetSettings: "Настройки виджета",
  info: "Информация",
  customIcon: "Пользовательская иконка",
  defaultSize: "Размер по умолчанию",
  category: "Категория",
  status: "Статус",
} as const;
export default smartBar;
